export enum AkaCriticalIllnessInsuranceType {
  AKA_CRITICAL_ILLNESS = "akacriticalIllness",
}

export enum CriticalIllnessInsuranceType {
  CRITICAL_ILLNESS_NOT_SMOKER = "criticalIllnessNotSmoker",
}

export enum DeathInsuranceType {
  DEATH_NOT_SMOKER = "deathNotSmoker",
}

export enum DisabilityInsuranceType {
  DISABILITY_FLEX = "disabilityFlex",
  DISABILITY_FLEX_NO_SINGLE_PAYMENT = "disabilityFlexNoSinglePayment",
  DISABILITY_FLEX_NO_SINGLE_PAYMENT_ADVISOR = "disabilityFlexNoSinglePaymentAdvisor",
}
